import { Caregiver } from "./Caregiver.ts";
import {
  PersonalizedDiabetesClinicalProtocol,
  PersonalizedHypertensionClinicalProtocol,
} from "./ClinicalProtocol.ts";
import Department from "./Department.ts";
import { UnreviewedDiabetesReadings, UnreviewedHypertensionReadings } from "./Patient";
import PatientStatus from "./PatientStatus";

export type PatientApiDto = {
  id: string;
  medicalRecordNumber: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  estimatedDateOfDelivery?: string;
  hypertension?: HypertensionFieldsApiDto;
  diabetes?: DiabetesFieldsApiDto;
};

export type HypertensionPatientApiDto = PatientApiDto & { hypertension: HypertensionFieldsApiDto };
export type DiabetesPatientApiDto = PatientApiDto & { diabetes: DiabetesFieldsApiDto };

export type HypertensionFieldsApiDto = {
  prescriptionId: string;
  diagnosis?: string;
  lastReviewTime?: string;
  firstReadingTime?: string;
  unreviewedReadings: UnreviewedHypertensionReadings;
  status: PatientStatus;
  personalizedClinicalProtocol: PersonalizedHypertensionClinicalProtocol;
  prescribingCaregiver: Caregiver;
  prescribingCaregiverDepartment?: Department;
  deliveryDate?: string;
};

export type DiabetesFieldsApiDto = {
  prescriptionId: string;
  diagnosis?: string;
  lastReviewTime?: string;
  firstReadingTime?: string;
  unreviewedReadings: UnreviewedDiabetesReadings;
  status: PatientStatus;
  personalizedClinicalProtocol: PersonalizedDiabetesClinicalProtocol;
  prescribingCaregiver: Caregiver;
  prescribingCaregiverDepartment?: Department;
  deliveryDate?: string;
};

export const hasHypertension = (patient: PatientApiDto): patient is HypertensionPatientApiDto =>
  !!patient.hypertension;

export const hasDiabetes = (patient: PatientApiDto): patient is DiabetesPatientApiDto =>
  !!patient.diabetes;
